import React from "react";

import styled from "@emotion/styled";

import { responsive } from "../../utils/style";
import { css } from "@emotion/react";

const StateDisplay = ({ state, totalState = 4, onChangeState }) => (
  <StateContainer>
    {new Array(totalState).fill(1).map((_, i) => (
      <>
        <StateCircle
          highlight={i < state}
          onClick={() => {
            if (i < state) onChangeState(i);
          }}
        >
          <StateLabel highlight={i < state}>{i + 1}</StateLabel>
        </StateCircle>
        {i + 1 < totalState && <StateLine />}
      </>
    ))}
  </StateContainer>
);

const Header = ({ weeks, steps, maxSteps, state, onChangeState }) => (
  <Container>
    <Status>{`สัปดาห์ที่ ${weeks} วันที่ ${steps}/${maxSteps}`}</Status>
    <StateDisplay state={state} onChangeState={onChangeState} />
  </Container>
);

const Container = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin: 40px 0;

  ${responsive.mobile(css`
    margin: 16px 0;
  `)}
`;

const Status = styled.span`
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;

  text-align: center;

  color: #a0abbb;

  ${responsive.mobile(css`
    font-size: 13px;
    line-height: 14px;
  `)}
`;

const StateContainer = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;

  margin-top: 16px;

  ${responsive.mobile(css`
    margin-top: 10px;
  `)}
`;

const StateCircle = styled.div`
  display: flex;

  width: 32px;
  height: 32px;

  background: ${(props) => (props.highlight ? "#FC6B4B" : "#fff2f0")};

  border: 2px solid #fc6b4b;
  border-radius: 50px;

  justify-content: center;
  align-items: center;

  cursor: ${(props) => (props.highlight ? "pointer" : "")};
`;

const StateLine = styled.div`
  width: 24px;
  height: 0;

  border: 1px solid #fc6b4b;
`;

const StateLabel = styled.span`
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;

  text-align: center;

  color: ${(props) => (props.highlight ? "#fff2f0" : "#fc6b4b")};
`;

export default Header;
